<div class="flex flex-col md:flex-row gap-4 w-full" [ngClass]="{ 'hidden' : !isVisible }">
    @for (column of groups.columns ; track column.index) {
        <div class="flex flex-col">
            @for (group of column.groups ; track group.name) {
                <magic-deck-group
                    [isOwnDeck]="isOwnDeck"
                    [group]="group"
                    [deck]="deck"
                    [deckComponent]="deckComponent"
                    [deckLayerComponent]="this"></magic-deck-group>
            }
        </div>
    }
</div>